import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";
import { useOrganization } from "../../../../store/organization";

import "./styles.scss";

export const Instructions = ({ onClose }) => {
  const { data: organizationData } = useOrganization(state => state.organization);

  return (
    <Dialog
      open={true}
      fullWidth={true}
      onClose={onClose}
      maxWidth="xs"
    >
      <DialogTitle style={{ paddingBottom: "5px" }}>
        <div className="tw-flex tw-justify-end">
          <Close color="disabled" className="tw-cursor-pointer" onClick={onClose} />
        </div>
      </DialogTitle>

      <DialogContent>
        <h2 className="tw-text-center tw-text-2xl tw-font-bold">How it Works</h2>

        <div className="instructions">
          {organizationData.instructions.map((inst, key) => (
            <div className="instruction" key={key}>
              <div className="instruction-number">
                <span>{key + 1}</span>
              </div>

              <div className="instruction-detail">
                <div className="instruction-title">
                  {inst.title}
                </div>

                <div className="instruction-description">
                  {inst.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>

      <div className="tw-flex tw-justify-center">
        <Button
          variant="contained"
          type="submit"
          className="tw-w-2/3"
          onClick={onClose}
          style={{
            backgroundColor: "#333",
            height: "50px",
            marginTop: "25px",
            marginBottom: "50px",
            width: "303px",
          }}
        >Done</Button>
      </div>
    </Dialog>
  );
};

Instructions.propTypes = {
  onClose: PropTypes.func,
};
